import type { AssetQaFindingDto } from '@/types/assetQa'

/**
 * What identifies a finding within a run, on screen.
 *
 * The check id when there is one. Findings on a run recorded before that field existed carry none,
 * and the code cannot stand in on its own — a code covers a class of mistake, so one run can hold
 * four findings that are all `C-CTS-07`, and keying on it would fold them into a single row and
 * mark them all as saving together. Position is the only thing that tells those apart, so the
 * fallback carries it.
 *
 * Deliberately UI-only. This is compared against other findings in the same rendered run and never
 * sent to the server, which is what makes a positional fallback safe here — the server matches on
 * the code and refuses when it is ambiguous, because there a collision would dismiss the wrong
 * finding rather than spin the wrong row.
 */
export function findingKey(
    finding: Pick<AssetQaFindingDto, 'CheckId' | 'Code'>,
    index: number
): string {
    return finding.CheckId || `${finding.Code}#${index}`
}
